import type { CellContext } from '@tanstack/react-table'

import { Link } from '@/components'
import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { Transaction } from '@/modules/projects'
import { statementPageUrl } from '@/modules/projects/utils'

export const DocumentCell = (cell: CellContext<Transaction, string>) => {
  const transaction = cell.row.original
  const fileName = cell.getValue()
  const fileUrl = transaction.statementFileUrl
  const sourcePage = transaction.sourcePage
  const searchQuery = cell.table.options.meta?.searchQuery

  if (fileUrl) {
    const href = statementPageUrl(fileUrl, sourcePage)
    return (
      <Link href={href} className="block truncate text-sm" theme="brand" newTab>
        <HighlightText text={fileName} query={searchQuery} />
      </Link>
    )
  }

  return (
    <span className="block truncate text-sm">
      <HighlightText text={fileName} query={searchQuery} />
    </span>
  )
}
